import i18n from '../i18n';
export function dateLocale(language = i18n.resolvedLanguage || i18n.language): string {
  const code=(language||'en').split('-')[0];
  return code==='pt'?'pt-BR':code==='es'?'es-AR':'en-US';
}
export function dateInputFormat(language = i18n.resolvedLanguage || i18n.language): string {
  return dateLocale(language)==='en-US'?'MM/DD/YYYY':'DD/MM/YYYY';
}
export function calendarDate(value: unknown): Date | null {
  if(value instanceof Date)return Number.isNaN(value.getTime())?null:value;
  if(typeof value!=='string'||!value)return null;
  const match=/^(\d{4})-(\d{2})-(\d{2})(?:$|[T ])/.exec(value);
  if(!match)return null;
  const [year,month,day]=match.slice(1).map(Number);
  const date=new Date(year,month-1,day);
  return date.getFullYear()===year&&date.getMonth()===month-1&&date.getDate()===day?date:null;
}
export function calendarDateValue(date: Date | null): string {
  return date?`${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`:'';
}
export function formatAppDate(value: unknown, language?: string): string {
  const date=calendarDate(value);
  return date?new Intl.DateTimeFormat(dateLocale(language),{day:'2-digit',month:'2-digit',year:'numeric'}).format(date):'—';
}
export function formatAppDateTime(value: unknown, language?: string): string {
  const date=value instanceof Date?value:typeof value==='string'&&value?new Date(value):null;
  return date&&!Number.isNaN(date.getTime())?new Intl.DateTimeFormat(dateLocale(language),{day:'2-digit',month:'2-digit',year:'numeric',hour:'2-digit',minute:'2-digit',hour12:dateLocale(language)==='en-US'}).format(date):'—';
}
export function parseAppDate(value: string, language?: string): Date | null {
  const iso=calendarDate(value);
  if(iso)return iso;
  const match=/^(\d{1,2})[/.\-](\d{1,2})[/.\-](\d{4})$/.exec(value.trim());
  if(!match)return null;
  const a=Number(match[1]), b=Number(match[2]), year=Number(match[3]);
  const [month,day]=dateLocale(language)==='en-US'?[a,b]:[b,a];
  return calendarDate(`${year}-${String(month).padStart(2,'0')}-${String(day).padStart(2,'0')}`);
}
